import Vue from "vue";
import filePreview from "@/packages/filePreview";
import wordPreview from "@/packages/wordPreview";
import excelPreview from "@/packages/excelPreview";
import pptPreview from "@/packages/pptPreview";
import pdfPreview from "@/packages/pdfPreview";
import imagePreview from "@/packages/imagePreview";
import videoPreview from "@/packages/videoPreview";

Vue.config.productionTip = false;

const components = [
  excelPreview,
  imagePreview,
  pdfPreview,
  pptPreview,
  videoPreview,
  wordPreview,
  filePreview,
];

const install = function (Vue) {
  if (install.installed) return;
  install.installed = true;
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  excelPreview,
  imagePreview,
  pdfPreview,
  pptPreview,
  videoPreview,
  wordPreview,
  filePreview,
};
